import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React from 'react';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import {
  CompanyData,
  PermissionsData,
  RolesEnum,
} from 'modules/authenticate/interfaces';
import clsx from 'clsx';
import { cyrb53Hash } from 'utils/helpers';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import TableTab from './TableTab';
import styles from './styles';

const useStyles = makeStyles(styles);

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && children}
    </div>
  );
};

interface PermissionTab {
  key: string;
  indexTab: number;
}

interface TabsCompanyProps {
  labels: Array<string>;
  panels: Array<React.ReactNode>;
  permissions?: PermissionsData;
  permissionTab: PermissionTab;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  onChange: (
    event: React.ChangeEvent<{}>,
    currentValue: number,
    currentTab: string
  ) => void;
}

const TabsCompany = ({
  labels,
  panels,
  role,
  companySelected,
  onChange,
  permissions,
  permissionTab,
}: TabsCompanyProps) => {
  const classes = useStyles();
  const [value, setValue] = React.useState<number>(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    onChange(event, newValue, labels[newValue]);
  };

  const hasPermission = (index: number) => {
    if (permissionTab.indexTab !== index) {
      return false;
    }
    return permissions && !permissions[permissionTab.key];
  };

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        color="default"
        className={clsx({
          [classes.barGreen]: inAdminView(role, companySelected),
          [classes.barGray]: inSuperAdminView(role, companySelected),
          [classes.barBlue]: inOperatorView(role, companySelected),
          [classes.barYellow]: companySelected,
        })}
      >
        <Tabs value={value} onChange={handleChange}>
          {labels.map((label, index) => (
            <Tab
              id={`tab-${label.toLowerCase()}`}
              key={label}
              disabled={hasPermission(index)}
              label={label}
              className={clsx({
                [`${classes.tabGreen} ${classes.tab}`]: inAdminView(
                  role,
                  companySelected
                ),
                [`${classes.tabGray} ${classes.tab}`]: inSuperAdminView(
                  role,
                  companySelected
                ),
                [`${classes.tabBlue} ${classes.tab}`]: inOperatorView(
                  role,
                  companySelected
                ),
                [`${classes.tabYellow} ${classes.tab}`]: companySelected,
              })}
            />
          ))}
        </Tabs>
      </AppBar>
      {panels.map((panel, index) => (
        <TabPanel key={cyrb53Hash(String(index))} value={value} index={index}>
          {panel}
        </TabPanel>
      ))}
    </div>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  permissions: data?.permissions,
  role: data?.role,
  companySelected,
});

export { TableTab };
export default connect(mapStateToProps)(TabsCompany);
